export interface CardFilter {
  id?: string | null;
  entityComponentId?: string;
  cardId?: string;
  propertyId?: string;
  groupId?: string;
  referencePropertyId?: string;
  propertyName: string;
  cardName?: string;
  value?: string;
  displayValue?: string;
  isDeleted?: boolean;
  type?: ReportFilterType;
  configs: CardFilterConfigs;
  valueList: EntityPropertyConfig[];
}

export interface CardFilterConfigs {
  componentType?: string;
  required?: boolean;
  order?: number
  fixedKey?: string;
}

export enum ReportFilterType {
  row,
  column
}

export interface EntityPropertyConfig {
  key?: string;
  value?: string;
  description?: string;
}

export interface ControlLabel {
  controlName: string;
  label?: string;
}

export interface ExtraData {
  id: string;
  value: string;
}